module.exports = __webpack_public_path__ + "img/modelug_10.f17723aa.png";